<template>
  <div id="app">
    <Header />
    <br />
    <router-view />
    <br />
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default {
  name: "app",
  components: {
    Header,
    Footer
  }
};
</script>

<style lang="scss">
@import "@/assets/css/style.scss";
/* App
-------------------------- */

html,
body {
  height: 100%;
  margin: 0px;
}

body {
  overflow-y: scroll;
}

#app {
  min-height: 100%;

  text-align: center;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;

  background-color: #f5f5f5;
  background-image: linear-gradient(#f1ecdc 0px, #f5f5f5 700px);
}
</style>
